import {TakeOneMapper} from '@/api/models/Feeds.ts';
import {ChangeFn} from '@/pages/feeds/Editor/Mapper/Mappers/index.tsx';
import {Slider} from '@blueprintjs/core';
import {ReactElement, useCallback, useEffect, useState} from 'react';

interface Props {
	mapper: TakeOneMapper,
	onChange: ChangeFn,
}

export default function TakeOneMapperEditor({mapper, onChange}: Props): ReactElement {
	const [value, setValue] = useState(mapper.index + 1);

	const onSliderRelease = useCallback((value: number) => {
		onChange({
			...mapper,
			index: value - 1,
		})
	}, [mapper, onChange]);

	useEffect(() => {
		setValue(mapper.index + 1);
	}, [mapper]);

	return (
		<>
			<Slider min={1} max={50} value={value} onChange={setValue} onRelease={onSliderRelease} labelStepSize={10} />
		</>
	);
}
